import { SpinResponse } from '@cgs/data-access';
import { Container } from '@cgs/wge';
import { T_GameStateMachineNotifierComponent } from '../../type_definitions';
import {
  GameStateMachineNotifierComponent,
  StateMachineListener,
} from './game_state_machine_notifier_component';

export class EndFreeSpinTriggerProvider extends StateMachineListener {
  constructor(container: Container) {
    super(container);
    const notifierComponent = container.resolve<GameStateMachineNotifierComponent>(
      T_GameStateMachineNotifierComponent
    );
    notifierComponent.notifier.addListener(this);
  }

  onEndFreeSpinsPopupExited(currentResponse: SpinResponse, previousResponse: SpinResponse): void {
    super.onEndFreeSpinsPopupExited(currentResponse, previousResponse);
  }
}
